import { render } from "./LookIndex.vue?vue&type=template&id=5f575b7e"
import script from "./LookIndex.vue?vue&type=script&lang=js"
export * from "./LookIndex.vue?vue&type=script&lang=js"
script.render = render

export default script